import {
  MailingObjectivesFormType,
  PITCH_TYPES,
  PitchType,
} from '@mailings/components/creators/personalized-mailing-creator-wizard/types/mailingObjectivesForm.types';
import Select, { type SelectOption } from '@semcore/ui/select';
import { Text } from '@semcore/ui/typography';
import { WithDataTestAttribute } from '@src/types/utility-types';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface PitchTypeSelectProps {
  excludedTypes?: PitchType[];
}

export const PitchTypeSelect = ({ excludedTypes }: PitchTypeSelectProps) => {
  const { t } = useTranslation(['mailings']);

  const { control } = useFormContext<MailingObjectivesFormType>();

  const options: WithDataTestAttribute<SelectOption>[] = PITCH_TYPES.filter(
    (value) => !excludedTypes?.includes(value),
  ).map((value) => ({
    value,
    label: t(`mailings:personalizedMailingCreatorWizard.objectivesForm.pitchType.${value}`),
    children: t(`mailings:personalizedMailingCreatorWizard.objectivesForm.pitchType.${value}`),
    'data-test': `pitch-type-option-${value}`,
  }));

  return (
    <div className="flex w-full items-center justify-between">
      <Text
        htmlFor="mailing-objectives-form-pitch-type-select"
        tag="label">
        {t('mailings:personalizedMailingCreatorWizard.objectivesForm.pitchType.pitchTypeLabel')}
      </Text>
      <div className="flex w-[600px] flex-col">
        <Controller
          control={control}
          name="pitchType"
          render={({ field }) => (
            <Select
              data-test="mailing-objectives-form-pitch-type-select"
              id="mailing-objectives-form-pitch-type-select"
              modifiers={[{ name: 'flip', enabled: true }]}
              options={options}
              placement="auto-start"
              size="l"
              {...field}
            />
          )}
        />
      </div>
    </div>
  );
};
